function addressFactor(value: any) {
    const temp = value?.split(',');
    return {
        state: temp?.at(-1),
        city: temp?.at(-2),
        street: temp?.at(-3) || '',
        full_address: value
    }
}

export function extractUAEAddressDetails(addressObj: any) {
    return extractIndiaAddressDetails(addressObj)

    // Check if addressObj and address_components are available
    if (!addressObj || !addressObj.address_components) {
        return;
    }

    let full_address = addressObj?.formatted_address || '';
    let zip_code = '';
    let country = '';
    let street_name = '';
    let house_no = '';
    let city = '';

    addressObj.address_components.forEach((element: any) => {
        // console.log('element', element);

        if (element.types.includes('route') || element.types.includes('sublocality_level_1')) {
            street_name = element?.long_name || '';
        }
        if (element.types.includes("country")) {
            country = element?.long_name || '';
        }
        if (element.types.includes("postal_code")) {
            zip_code = element?.long_name || '';
        }
        if (element.types.includes("street_number")) {
            house_no = element?.long_name || '';
        }
        if (element.types.includes("sublocality") || element.types.includes("locality") || element.types.includes("administrative_area_level_1")) {
            city = element?.long_name || '';
        }
    });

    // Return the extracted details
    return {
        full_address,
        street_name,
        house_no,
        city,
        country,
        zip_code
    };
}
export function extractIndiaAddressDetails(addressObj: any) {
    if (!addressObj || !addressObj.address_components) {
        return;
    }

    let zip_code = '';
    let country = '';
    let street_name = '';
    let house_no_1 = '';
    let area = '';
    let city = '';
    let district = '';
    let state = '';

    addressObj.address_components.forEach((element: any) => {
        if (element.types.includes("premise")) {
            house_no_1 = element.long_name;
        }
        if (element.types.includes("sublocality_level_1")) {
            street_name = element.long_name;
        }
        if (element.types.includes("sublocality_level_2")) {
            area = element.long_name;
        }
        if (element.types.includes("locality") || element.types.includes("administrative_area_level_3")) {
            city = element.long_name;  // Use administrative_area_level_3 as the city
        }
        if (element.types.includes("administrative_area_level_2")) {
            district = element.long_name;
        }
        if (element.types.includes("administrative_area_level_1")) {
            state = element.long_name;
        }
        if (element.types.includes("postal_code")) {
            zip_code = element.long_name;
        }
        if (element.types.includes("country")) {
            country = element.long_name;
        }
    });

    // Combine house_no_1 (premise) and street_name (sublocality_level_1)
    let full_street_name = [house_no_1, street_name].filter(Boolean).join(" ");

    // Remove duplicates from address parts
    let addressParts = [
        house_no_1 ? house_no_1 : street_name,
        area,
        city,
        district,
        state,
        zip_code,
        country
    ];

    // Remove any duplicate values
    addressParts = Array.from(new Set(addressParts));

    // Generate the full address (without duplicates)
    let full_address = addressParts.filter(Boolean).join(", ");
    let house_no = ''; // Assuming house_no_1 is the desired house number.

    return {
        full_address,
        house_no,
        street_name: full_street_name, // Use combined street name
        area,
        city,
        district,
        state,
        country,
        zip_code
    };
}



export default addressFactor